import { render, staticRenderFns } from "./Startup.vue?vue&type=template&id=2b7fecee"
import script from "./Startup.vue?vue&type=script&lang=js"
export * from "./Startup.vue?vue&type=script&lang=js"
import style0 from "./Startup.vue?vue&type=style&index=0&id=2b7fecee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports